import api from '../../../services/api';

export interface OrderStatusChangePayload {
  status: string;
  notes?: string;
  forceWithoutWZ?: boolean;
}

export async function changeOrderStatus(orderId: string, payload: OrderStatusChangePayload): Promise<any> {
  const response = await api.patch(`/orders/${orderId}/status`, payload);
  return response.data;
}

export async function sendCustomerConfirmationEmail(
  orderId: string,
  options: { language?: 'pl' | 'en'; subject?: string; message?: string; html?: string } = {}
): Promise<{ success: boolean; recipient: string }> {
  const response = await api.post(`/orders/${orderId}/send-customer-confirmation`, options);
  return response.data;
}

export interface CustomerConfirmationPreview {
  subject: string;
  html: string;
  message: string;
  recipient: string | null;
  customerName: string | null;
  customerConfirmation?: {
    canSend: boolean;
    disabledReason: string | null;
  };
}

export async function previewCustomerConfirmationEmail(
  orderId: string,
  language: 'pl' | 'en' = 'pl'
): Promise<CustomerConfirmationPreview> {
  const response = await api.get(`/orders/${orderId}/customer-confirmation-preview`, {
    params: { language }
  });
  return response.data;
}

export async function previewCustomerConfirmationEmailDraft(
  orderId: string,
  payload: { language?: 'pl' | 'en'; subject?: string; message?: string }
): Promise<CustomerConfirmationPreview> {
  const response = await api.post(`/orders/${orderId}/customer-confirmation-preview`, payload);
  return response.data;
}

export interface CustomerStatusEmailPreview {
  subject: string;
  html: string;
  message: string;
  recipient: string | null;
  customerName: string | null;
  customerStatusEmail?: {
    canSend: boolean;
    disabledReason: string | null;
  };
}

export async function previewCustomerStatusEmail(
  orderId: string
): Promise<CustomerStatusEmailPreview> {
  const response = await api.get(`/orders/${orderId}/customer-status-email-preview`);
  return response.data;
}

export async function previewCustomerStatusEmailDraft(
  orderId: string,
  payload: { subject?: string; message?: string }
): Promise<CustomerStatusEmailPreview> {
  const response = await api.post(`/orders/${orderId}/customer-status-email-preview`, payload);
  return response.data;
}

export async function sendCustomerStatusEmail(
  orderId: string,
  payload: { subject?: string; message?: string; html?: string } = {}
): Promise<{ success: boolean; recipient: string }> {
  const response = await api.post(`/orders/${orderId}/send-customer-status-email`, payload);
  return response.data;
}
